import './styles/tokens.css';
import './styles/reset.css';
import './styles/global.css';
import App from './App.svelte';
import { mount } from 'svelte';

const objetivo = document.getElementById('app');

if (!objetivo) {
  throw new Error('No se encontró el elemento #app en el DOM.');
}

const aplicacion = mount(App, { target: objetivo });

export default aplicacion;
